/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetPossibleProcessStatusesResponseDto } from '../models';
// @ts-ignore
import type { GetProcessCandidatesStatisticsResponseDto } from '../models';
// @ts-ignore
import type { GetProcessStatusResponseDto } from '../models';
// @ts-ignore
import type { ProcessDto } from '../models';
// @ts-ignore
import type { SetProcessStatusRequestDto } from '../models';
/**
 * ProcessesRestApi - axios parameter creator
 */
export const ProcessesRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get possible process statuses
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPossibleProcessStatuses: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getPossibleProcessStatuses', 'processId', processId)
            const localVarPath = `/api/v1/processes/{processId}/possible-statuses`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCandidatesStatistics: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessCandidatesStatistics', 'processId', processId)
            const localVarPath = `/api/v1/processes/{processId}/candidates-statistics`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a recruitment process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessDetails: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessDetails', 'processId', processId)
            const localVarPath = `/api/v1/processes/{processId}`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get process status
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessStatus: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessStatus', 'processId', processId)
            const localVarPath = `/api/v1/processes/{processId}/status`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import active eRecruiter recruitments as processes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importExternalRecruitmentsAsProcesses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/processes/import-external-recruitments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset automatic restart counter and schedule process retry
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryProcess: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('retryProcess', 'processId', processId)
            const localVarPath = `/api/v1/processes/{processId}/retry`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set process status
         * @param {string} processId 
         * @param {SetProcessStatusRequestDto} setProcessStatusRequestDto Process status details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProcessStatus: async (processId: string, setProcessStatusRequestDto: SetProcessStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('setProcessStatus', 'processId', processId)
            // verify required parameter 'setProcessStatusRequestDto' is not null or undefined
            assertParamExists('setProcessStatus', 'setProcessStatusRequestDto', setProcessStatusRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/status`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setProcessStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncProcessWithExternalRecruitment: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('syncProcessWithExternalRecruitment', 'processId', processId)
            const localVarPath = `/api/v1/processes/{processId}/sync`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessesRestApi - functional programming interface
 */
export const ProcessesRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessesRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get possible process statuses
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPossibleProcessStatuses(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPossibleProcessStatusesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPossibleProcessStatuses(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesRestApi.getPossibleProcessStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessCandidatesStatistics(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProcessCandidatesStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessCandidatesStatistics(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesRestApi.getProcessCandidatesStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a recruitment process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessDetails(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessDetails(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesRestApi.getProcessDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get process status
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessStatus(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProcessStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessStatus(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesRestApi.getProcessStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import active eRecruiter recruitments as processes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importExternalRecruitmentsAsProcesses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importExternalRecruitmentsAsProcesses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesRestApi.importExternalRecruitmentsAsProcesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset automatic restart counter and schedule process retry
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryProcess(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryProcess(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesRestApi.retryProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set process status
         * @param {string} processId 
         * @param {SetProcessStatusRequestDto} setProcessStatusRequestDto Process status details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setProcessStatus(processId: string, setProcessStatusRequestDto: SetProcessStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setProcessStatus(processId, setProcessStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesRestApi.setProcessStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncProcessWithExternalRecruitment(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncProcessWithExternalRecruitment(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesRestApi.syncProcessWithExternalRecruitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessesRestApi - factory interface
 */
export const ProcessesRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessesRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Get possible process statuses
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPossibleProcessStatuses(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPossibleProcessStatusesResponseDto> {
            return localVarFp.getPossibleProcessStatuses(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCandidatesStatistics(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetProcessCandidatesStatisticsResponseDto> {
            return localVarFp.getProcessCandidatesStatistics(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a recruitment process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessDetails(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessDto> {
            return localVarFp.getProcessDetails(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get process status
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessStatus(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetProcessStatusResponseDto> {
            return localVarFp.getProcessStatus(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import active eRecruiter recruitments as processes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importExternalRecruitmentsAsProcesses(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.importExternalRecruitmentsAsProcesses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset automatic restart counter and schedule process retry
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryProcess(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.retryProcess(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set process status
         * @param {string} processId 
         * @param {SetProcessStatusRequestDto} setProcessStatusRequestDto Process status details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProcessStatus(processId: string, setProcessStatusRequestDto: SetProcessStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setProcessStatus(processId, setProcessStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncProcessWithExternalRecruitment(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncProcessWithExternalRecruitment(processId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessesRestApi - interface
 */
export interface ProcessesRestApiInterface {
    /**
     * 
     * @summary Get possible process statuses
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPossibleProcessStatuses(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPossibleProcessStatusesResponseDto>;

    /**
     * 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessCandidatesStatistics(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetProcessCandidatesStatisticsResponseDto>;

    /**
     * 
     * @summary Get details of a recruitment process
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessDetails(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessDto>;

    /**
     * 
     * @summary Get process status
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessStatus(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetProcessStatusResponseDto>;

    /**
     * 
     * @summary Import active eRecruiter recruitments as processes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importExternalRecruitmentsAsProcesses(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Reset automatic restart counter and schedule process retry
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryProcess(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Set process status
     * @param {string} processId 
     * @param {SetProcessStatusRequestDto} setProcessStatusRequestDto Process status details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setProcessStatus(processId: string, setProcessStatusRequestDto: SetProcessStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Sync process
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncProcessWithExternalRecruitment(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ProcessesRestApi - object-oriented interface
 */
export class ProcessesRestApi extends BaseAPI implements ProcessesRestApiInterface {
    /**
     * 
     * @summary Get possible process statuses
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPossibleProcessStatuses(processId: string, options?: RawAxiosRequestConfig) {
        return ProcessesRestApiFp(this.configuration).getPossibleProcessStatuses(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessCandidatesStatistics(processId: string, options?: RawAxiosRequestConfig) {
        return ProcessesRestApiFp(this.configuration).getProcessCandidatesStatistics(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a recruitment process
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessDetails(processId: string, options?: RawAxiosRequestConfig) {
        return ProcessesRestApiFp(this.configuration).getProcessDetails(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get process status
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessStatus(processId: string, options?: RawAxiosRequestConfig) {
        return ProcessesRestApiFp(this.configuration).getProcessStatus(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import active eRecruiter recruitments as processes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importExternalRecruitmentsAsProcesses(options?: RawAxiosRequestConfig) {
        return ProcessesRestApiFp(this.configuration).importExternalRecruitmentsAsProcesses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset automatic restart counter and schedule process retry
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retryProcess(processId: string, options?: RawAxiosRequestConfig) {
        return ProcessesRestApiFp(this.configuration).retryProcess(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set process status
     * @param {string} processId 
     * @param {SetProcessStatusRequestDto} setProcessStatusRequestDto Process status details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setProcessStatus(processId: string, setProcessStatusRequestDto: SetProcessStatusRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesRestApiFp(this.configuration).setProcessStatus(processId, setProcessStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync process
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public syncProcessWithExternalRecruitment(processId: string, options?: RawAxiosRequestConfig) {
        return ProcessesRestApiFp(this.configuration).syncProcessWithExternalRecruitment(processId, options).then((request) => request(this.axios, this.basePath));
    }
}

